module.exports = __webpack_public_path__ + "img/img3.687f007c.png";